import React from "react";
import Modal from "../../../../components/modal";
import { BTN_SECUNDARIO } from "../../paineis-admin/components/shared";

interface Props {
  nome: string;
  promovendo: boolean;
  onConfirmar: () => void;
  onClose: () => void;
}

const BTN_PRIMARIO =
  "flex items-center justify-center gap-2 rounded-xl bg-brand-500 px-5 py-2.5 text-sm font-bold text-white shadow-dv-md transition-all hover:bg-brand-600 active:scale-[.98] disabled:cursor-not-allowed disabled:opacity-50";

/**
 * Promover torna a pessoa colaboradora da DataValue (login interno ao entrar com a Microsoft).
 * Quem queria dar acesso como usuário de cliente usava o botão errado — daí a confirmação.
 */
const ConfirmarPromoverModal: React.FC<Props> = ({ nome, promovendo, onConfirmar, onClose }) => (
  <Modal onClose={onClose}>
    <div
      onClick={(e) => e.stopPropagation()}
      aria-labelledby="promover-titulo"
      className="w-full max-w-md space-y-4 rounded-[20px] bg-white p-6 shadow-dv-md dark:bg-navy-800"
    >
      <h2 id="promover-titulo" className="font-display text-lg font-extrabold text-navy-700 dark:text-white">
        Promover a colaborador
      </h2>
      <p className="text-sm text-gray-600 dark:text-gray-300">
        Promover torna <strong>{nome}</strong> <strong>colaborador da DataValue</strong>: ao entrar com a
        Microsoft, ganha login interno. Para dar acesso como <strong>usuário de um cliente</strong>, use
        Acessos → Convidar (e o Entra Tenant Id no cadastro do cliente).
      </p>
      <div className="flex justify-end gap-2">
        <button type="button" className={BTN_SECUNDARIO} onClick={onClose}>
          Cancelar
        </button>
        <button type="button" className={BTN_PRIMARIO} onClick={onConfirmar} disabled={promovendo}>
          {promovendo ? "Promovendo…" : "Promover"}
        </button>
      </div>
    </div>
  </Modal>
);

export default ConfirmarPromoverModal;
